import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useContext } from 'react';
import { siteMapPropType } from '@bingads-webui-campaign-react/with-site-map';
import { StyledSubPageMenu } from '@bingads-webui-campaign-react/sub-page-menu';
import { Activity, Scenario } from '@bingads-webui-react/hoc-with-signal';
import { StyledMenuItemTag } from '@bingads-webui-react/menu-item-tag';
import { I18nContext } from '@bingads-webui-react/i18n-context';

export const Loader = (props) => {
  const { siteMap, updateAvailability } = props;
  const i18n = useContext(I18nContext);

  const onTabItemRender = useCallback((item) => {
    if (item.id === 'uet-tag-insights') {
      const pillStyle = { marginLeft: 5, verticalAlign: 'top', display: 'inline-block' };

      return (
        <div style={pillStyle}>
          <StyledMenuItemTag tagClass="blueTag" tagContent={i18n.getString(_TL_('BETA'))} />
        </div>);
    }
    return null;
  }, [i18n]);

  const selectedParent = _.findWhere(siteMap, { selected: true });
  const available = !_.isEmpty(selectedParent);
  useEffect(() => {
    updateAvailability(available);
  });

  return props.isVisible ? (
    <Scenario name="sub-page-memu">
      <Activity name="default-sub-page-memu">
        <StyledSubPageMenu {...props} selectedParent={selectedParent && selectedParent.id} onTabItemRender={onTabItemRender} />
      </Activity>
    </Scenario>
  ) : null;
};

Loader.propTypes = {
  siteMap: siteMapPropType.isRequired,
  updateAvailability: PropTypes.func,
  isVisible: PropTypes.bool.isRequired,
  changeLayout: PropTypes.func.isRequired,
};

Loader.defaultProps = {
  updateAvailability: _.noop,
};

export const UetTagSubPageMenu = React.memo(Loader);
